// extracted by mini-css-extract-plugin
module.exports = {"PrintoutsSettings":"PrintoutsSettings___3Wcke","pageTitle":"pageTitle___tP0SH"};